<template>
  <aside :class="['main-sidebar', 'col-12', 'col-md-3', 'col-lg-2', 'px-0', sidebarVisible ? 'open' : '']">
      <div class="main-navbar">
        <nav class="navbar align-items-stretch navbar-light bg-white flex-md-nowrap border-bottom p-0" style="height: 7.75rem;">
          <router-link class="navbar-brand w-100 mr-1" to="/kokpit" style="line-height: 25px; height: 6.75rem;">
            <div class="d-table m-auto">
              <img id="main-logo" class="d-inline-block align-top mr-1" style="max-width: 110px;" src="@/assets/images/logo.png" alt="CRM">
            </div>
          </router-link>
          <a class="toggle-sidebar d-sm-inline d-md-none d-lg-none" @click="handleToggleSidebar()">
            <i class="material-icons">&#xE5C4;</i>
          </a>
        </nav>
      </div>

      <form action="#" class="main-sidebar__search w-100 border-right d-sm-flex d-md-none d-lg-none">
        <div class="input-group input-group-seamless ml-3">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i class="fas fa-search"></i>
            </div>
          </div>
          <input class="navbar-search form-control" type="text" placeholder="Search for something..." aria-label="Search">
        </div>
      </form>
      <div class="nav-wrapper">
          <d-nav class="flex-column">
            <li v-for="(item, navItemIdx) in items"
                :key="navItemIdx"
                class="nav-item dropdown"
            >
              <d-link
                :class="['nav-link', item.items && item.items.length ? 'dropdown-toggle' : '']"
                v-if="item.visible() === 1" :to="item.to"
                v-d-toggle="`snc-${navItemIdx}`"
              >
                <div class="item-icon-wrapper"
                     v-if="item.htmlBefore"
                     v-html="item.htmlBefore">

                </div>
                <span v-if="item.title">
                  {{ item.title }}
                </span>
                <span class="ml-2"
                      v-if="item.title === 'Listy rezerwowe' && reservationStats.all !== 0">
                  <d-badge
                    v-if="reservationStats.all !== 0"
                    :theme="'danger'"
                    :class="'ml-1 mr-1 reservation-badge-head'">
                    {{reservationStats.all}}
                  </d-badge>
                </span>
                <div
                  class="item-icon-wrapper"
                  v-if="item.htmlAfter"
                  v-html="item.htmlAfter">
                </div>
              </d-link>
              <d-collapse
                v-if="item.items && item.items.length"
                :id="`snc-${navItemIdx}`"
                class="dropdown-menu dropdown-menu-small"
                accordion="sidebar-items-accordion"
              >
                <d-dropdown-item
                  v-for="(subItem, subItemIdx) in item.items"
                  v-if="subItem.visible() === 1"
                  :key="subItemIdx"
                  :href="subItem.href"
                  :to="subItem.to"
                >
                  {{ subItem.title }}
                  <span
                    class="ml-2"
                    v-if="subItem.title === 'Nowe wizyty' && reservationStats.first_visit !== 0"
                  >
                    <d-badge
                      class="reservation-badge"
                      :theme="'danger'"
                      :class="'ml-1 mr-1'">
                      {{reservationStats.first_visit}}
                    </d-badge>
                    </span>
                  <span
                    class="ml-2"
                    v-if="subItem.title === 'Kontynuacje wizyt' && reservationStats.another_visit !== 0"
                  >
                    <d-badge
                      class="reservation-badge"
                      :theme="'danger'"
                      :class="'ml-1 mr-1'">
                      {{reservationStats.another_visit}}
                    </d-badge>
                  </span>
                </d-dropdown-item>
              </d-collapse>
            </li>
          </d-nav>
      </div>
  </aside>
</template>

<script>
export default {
  name: 'main-sidebar',
  props: {
    /**
     * Whether to hide the logo text, or not.
     */
    hideLogoText: {
      type: Boolean,
      default: false,
    },
    /**
     * The menu items.
     */
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sidebarVisible: false,
    };
  },
  computed: {
    reservationStats () {
      return this.$store.getters.getNumbersReservationStats
    }
  },
  created() {
    this.$bus.$on('toggle-sidebar', this.handleToggleSidebar);
    this.reservationStatsGet();
  },
  beforeDestroy() {
    this.$bus.$off('toggle-sidebar');
  },
  methods: {
    reservationStatsGet () {
      this.$store.dispatch('patientsReservationStatsGet')
    },
    handleToggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
  },
};
</script>

<style lang="scss">
  .nav-link {
    padding: 1rem 1rem 1rem 0.7rem !important;
  }
  .main-sidebar {
    .item-icon-wrapper {
      display: inline-block;
    }
    .dropdown-menu {
      display: block;
    }
    .main-sidebar-green {
      color: #17c671;
    }
    .main-sidebar-gray {
      color: #868e96;
    }
    .reservation-badge {
      padding: 5px 8px;
      border-radius: 40px;
      font-size: 0.7rem;
      display: inline-block;
    }
    .reservation-badge-head {
      padding: 4px 6px;
      border-radius: 40px;
      font-size: 0.7rem;
      color: #c4183c;
      background-color: #fff;
      border: 2px solid;
      display: inline-block;
    }
  }
</style>
